import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { GmailReview } from "./GmailReview";
type Review = {
  name: string;
  email: string;
  subject: string;
  body: string;
  time: string;
  initials: string;
  color: string;
};
type Props = {
  reviews: Review[];
};
export function ReviewCarousel({
  reviews
}: Props) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  useEffect(() => {
    if (reviews.length < 2) return;
    const timer = window.setInterval(() => {
      setDirection(1);
      setActiveIndex(current => (current + 1) % reviews.length);
    }, 5500);
    return () => window.clearInterval(timer);
  }, [reviews.length]);
  if (reviews.length === 0) return null;
  const goTo = (nextIndex: number) => {
    const normalizedIndex = (nextIndex + reviews.length) % reviews.length;
    setDirection(normalizedIndex > activeIndex ? 1 : -1);
    setActiveIndex(normalizedIndex);
  };
  const review = reviews[activeIndex];
  return <div className="relative" data-id="element-201" data-mp="3mzfvcetiw7m0">
      <div className="overflow-hidden" data-id="element-202" data-mp="3myehk2l4h70l">
        <AnimatePresence initial={false} mode="wait" custom={direction} data-id="element-203" data-mp="3rqo3z8n13oy4">
          <motion.div key={review.email} custom={direction} initial={{
          opacity: 0,
          x: direction * 32
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: direction * -32
        }} transition={{
          duration: 0.28,
          ease: "easeOut"
        }} drag="x" dragConstraints={{
          left: 0,
          right: 0
        }} dragElastic={0.18} onDragEnd={(_, info) => {
          if (info.offset.x < -55) goTo(activeIndex + 1);
          if (info.offset.x > 55) goTo(activeIndex - 1);
        }} className="cursor-grab active:cursor-grabbing" data-id="element-204" data-mp="3rtk3h1eiyloo">
            <GmailReview {...review} data-id="element-205" data-mp="t891ynv28s6q" />
          </motion.div>
        </AnimatePresence>
      </div>

      <div className="mt-3 flex items-center justify-center gap-3" data-id="element-206" data-mp="2pbng9i7x4zi8">
        <button type="button" onClick={() => goTo(activeIndex - 1)} aria-label="Ver reseña anterior" className="flex h-8 w-8 items-center justify-center rounded-full border border-[#1f4d3a]/15 bg-white text-[#1f4d3a] transition-colors hover:bg-[#e7f0ea] focus:outline-none focus:ring-2 focus:ring-[#c7a24a]" data-id="element-207" data-mp="2kdvpirj0fjfm">
          <ChevronLeftIcon className="h-4 w-4" data-id="element-208" data-mp="26mh0o42f8o0n" />
        </button>

        <div className="flex items-center gap-1.5" role="tablist" aria-label="Reseñas de clientes" data-id="element-209" data-mp="21o70ff1uax86">
          {reviews.map((item, index) => <button key={item.email} type="button" onClick={() => goTo(index)} aria-label={`Ver reseña ${index + 1} de ${reviews.length}`} aria-selected={activeIndex === index} role="tab" className={`h-2 rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-[#c7a24a] ${activeIndex === index ? "w-5 bg-[#1f4d3a]" : "w-2 bg-[#1f4d3a]/25 hover:bg-[#1f4d3a]/50"}`} data-id="element-210" data-mp="2fgdi55kn5c9q" data-mpi={index} />)}
        </div>

        <button type="button" onClick={() => goTo(activeIndex + 1)} aria-label="Ver siguiente reseña" className="flex h-8 w-8 items-center justify-center rounded-full border border-[#1f4d3a]/15 bg-white text-[#1f4d3a] transition-colors hover:bg-[#e7f0ea] focus:outline-none focus:ring-2 focus:ring-[#c7a24a]" data-id="element-211" data-mp="ywcun7j2xktr">
          <ChevronRightIcon className="h-4 w-4" data-id="element-212" data-mp="1hlt26et6mdjo" />
        </button>
      </div>
    </div>;
}